var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStepComplete01 = function SvgStepComplete01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 34.04,
    y1: 145.34,
    x2: 199.6,
    y2: 12.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.66,
    y1: 149.87,
    x2: 203.23,
    y2: 17.42,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.02,69.35l-50.13,50.13-21.91-21.91c-2.06-2.06-5.39-2.06-7.45,0-2.06,2.06-2.06,5.39,0,7.45l25.64,25.64c1.03,1.03,2.38,1.54,3.73,1.54s2.7-.51,3.73-1.54l53.86-53.86c2.06-2.06,2.06-5.39,0-7.45-2.06-2.06-5.39-2.06-7.45,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.71,29.29C151.82,10.4,126.71,0,100,0S48.18,10.4,29.29,29.29C10.4,48.18,0,73.29,0,100s10.4,51.82,29.29,70.71c18.89,18.89,44,29.29,70.71,29.29s51.82-10.4,70.71-29.29c18.89-18.89,29.29-44,29.29-70.71s-10.4-51.82-29.29-70.71ZM100,189.46c-49.33,0-89.46-40.13-89.46-89.46S50.67,10.54,100,10.54s89.46,40.13,89.46,89.46-40.13,89.46-89.46,89.46Z"
  })));
};
export default SvgStepComplete01;